<template>
  <div class="IntroPen text-NotoSansRegular">
    <!-- BANNER -->
    <div class="BN flex pt-48 md:pt-64 pb-4 md:pb-10 flex-wrap px-8 md:px-12 lg:px-20">
      <div class="w-full md:w-2/5 md:px-6 lg:px-8">
        <img src="~@/assets/images/readingPen2/livepen-logo-03.png"
          class="mb-3 md:mb-4 lg:mb-5 max-w-full object-contain w-4/5 md:w-auto" alt="Logo">

        <img src="~@/assets/images/readingPen2/word-01.png"
          class="max-w-full object-contain w-4/5 md:w-auto" alt="隨點隨念">

        <!-- <div class="mt-2 lg:mt-6 items-center justify-start hidden md:flex">
          <img src="~@/assets/images/readingPen2/prices-2.png" alt="課程朗讀一點就通" class="max-w-full object-contain mr-1">
          <div>
            <p class="text-5xl m-0" v-if="price">{{ price }}</p>
          </div>
        </div> -->
        <!-- <button class="bg-white rounded px-10 py-2 hidden md:flex focus:outline-none buy-Btn hover:text-white" @click="toBuySmart">立即訂購</button> -->
      </div>
      <div class="w-4/5 md:w-3/5 mt-8 md:mt-0 mx-auto md:px-6 lg:px-12 xl:px-16">
        <img src="~@/assets/images/readingPen2/PD-01.png" alt="課程朗讀一點就通" class="max-w-full object-contain mx-auto" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true">
      </div>

      <!-- mobile-btn -->
      <!-- <div class="w-full mobile flex justify-center items-center md:hidden mt-2">
        <button class="bg-white rounded focus:outline-none text-sm h-10 w-32 mx-2" @click="toBuySmart">立即訂購</button>

        <div class="items-center justify-start flex mx-2">
          <img src="~@/assets/images/readingPen2/prices-2.png" alt="課程朗讀一點就通" class="max-w-full object-contain mx-auto mr-1">
          <div>
            <p class="text-4xl m-0 font-bold -mt-2" v-if="price">{{ price }}</p>
          </div>
        </div>
      </div> -->
    </div>
    <!-- 課程朗讀一點就通。 -->
    <div class="flex flex-wrap bg-white pt-8 pb-4 md:py-12 px-6">
      <div class="w-full md:w-1/2 order-2 md:order-1 md:px-4 xl:px-0">
        <div class="video-container" data-aos="fade-in" data-aos-easing="ease" data-aos-once="false">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/jwffZVS--sg" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
      <div class="w-full md:w-1/2 flex flex-col justify-center order-1 md:order-2 mb-4 md:mb-0 md:px-4 xl:px-5">
        <h3 class="text-xl lg:text-3xl md:text-center font-bold ml-1 md:ml-0">課程朗讀一點就通</h3>
        <h3 class="text-xl lg:text-3xl md:text-center mb-2 md:mb-4 font-bold ml-1 md:ml-0">24小時語言隨身家教</h3>
        <p class="text-sm md:text-base lg:text-xl text-center leading-relaxed">LiveABC智慧點讀筆，使用高品質的光學感應筆頭，書中的單字、句子、段落都可隨點隨聽，走到哪、讀到哪、聽到哪，不受任何時間地點限制，攜帶方便，外型輕巧時尚，符合現代人講究方便、快速、有效的學習需求，一筆在手，學語言練聽力更輕鬆。</p>
      </div>
    </div>
    <!-- 3步驟快速安裝點讀音檔 -->
    <div class="flex flex-wrap bg-white pt-8 pb-4 md:py-12 px-6">
      <div class="w-full md:w-1/2 order-2 md:px-4 xl:px-0">
        <div class="video-container" data-aos="fade-in" data-aos-easing="ease" data-aos-once="false">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/pQNfu8p4DH4" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
      <div class="w-full md:w-1/2 flex flex-col justify-center order-1 mb-4 md:mb-0 md:px-4 xl:px-5">
        <h3 class="text-xl lg:text-3xl md:text-center font-bold ml-1 md:ml-0">3步驟快速安裝點讀音檔</h3>
        <h3 class="text-xl lg:text-3xl md:text-center mb-2 md:mb-4 font-bold ml-1 md:ml-0">隨點隨唸 學習超方便！</h3>
        <p class="text-sm md:text-base lg:text-xl text-center leading-relaxed">點讀筆出廠時會預置部分熱門書籍的點讀音檔，如果聽到No Message或Wow的訊息音，代表記憶卡內沒有音檔，使用者可依實際需求新增或刪除點讀音檔。 更多點讀筆使用常見問題可以點選
          <router-link class="underline text-blue-600" :to="{ name: 'service', params: { id: 'smartPen' } }">Q&A</router-link>。</p>
      </div>
    </div>
    <!-- 高品質光學 感應筆頭 -->
    <div class="flex pt-4 md:pt-16 md:pb-8 sensitive flex-wrap md:px-6">
      <div class="w-full md:w-1/2 lg:w-2/5 mb-4 px-6">
        <h3 class="text-2xl lg:text-3xl md:text-center font-bold mb-2 md:mb-4">高品質光學 感應筆頭</h3>
        <p class="text-sm md:text-base lg:text-xl md:text-center leading-relaxed">以筆尖輕觸頁面上的文字或圖片，即可播放朗讀音檔，隨點隨聽，學習零距離。</p>
        <!-- <p class="text-sm md:text-base lg:text-xl md:text-center leading-relaxed">朗讀音檔，隨點隨聽，學習零距離。</p> -->
      </div>
      <div class="w-full md:w-1/2 lg:w-3/5 lg:pl-10 mt-6 md:mt-0 flex justify-end"  data-aos="fade-left" data-aos-easing="ease" data-aos-once="false">
        <img src="~@/assets/images/readingPen2/pen-01.png" alt="點讀筆" class="max-w-full object-contain hidden md:block">
        <img src="~@/assets/images/readingPen2/pen-02.png" alt="點讀筆" class="w-full max-w-full object-contain md:hidden pl-6">
      </div>
    </div>
    <!-- 點讀/錄音/MP3 三機一體 -->
    <div class="flex flex-wrap pt-12 pb-72 md:pt-20 md:pb-32 lg:py-24 md:pl-12 xl:pl-20 combine justify-center md:justify-start w-full">
      <div class="flex flex-wrap flex-col">
        <div class="flex mb-4 px-4 order-2 md:order-1">
          <img src="~@/assets/images/readingPen2/icon-02.png" alt="livaABC" class="max-w-full object-contain mx-auto h-16 lg:h-auto" data-aos="fade-right" data-aos-easing="ease" data-aos-once="false">
          <img src="~@/assets/images/readingPen2/icon-01.png" alt="livaABC" class="max-w-full object-contain mx-auto h-16 lg:h-auto" data-aos="fade-right" data-aos-easing="ease" data-aos-once="false" data-aos-delay="50">
          <img src="~@/assets/images/readingPen2/icon-03.png" alt="livaABC" class="max-w-full object-contain mx-auto h-16 lg:h-auto" data-aos="fade-right" data-aos-easing="ease" data-aos-once="false" data-aos-delay="150">
        </div>
        <div class="order-1 md:order-2 mb-4">
          <h3 class="text-xl lg:text-3xl text-center font-bold mb-3 lg:mb-4">點讀/錄音/MP3 三機一體</h3>
          <p class="text-sm md:text-base lg:text-xl text-center leading-relaxed">同時具備三大功能，點讀聽原音朗讀、</p>
          <p class="text-sm md:text-base lg:text-xl text-center leading-relaxed">錄音跟讀開口說、播放課程MP3整段聽。</p>
        </div>
      </div>
    </div>
    <!-- 附字典卡 輕鬆查單字/LiveABC 出版品通/容量 存書方便 -->
    <div class="flex flex-wrap bg-white py-10 md:py-8 px-6 md:px-12">
      <div class="w-full md:w-1/3 px-2 xl:px-4 flex flex-col" data-aos="fade-top" data-aos-easing="ease" data-aos-once="false">
        <img src="~@/assets/images/readingPen2/photo-02.png" alt="livaABC" class="max-w-full object-contain mx-auto order-3 md:order-1">
        <div class="order-1 md:order-2">
          <h5 class="text-xl lg:text-2xl text-center font-bold order-1 md:order-2 mb-1 md:mt-6">附字典卡 輕鬆查單字</h5>
          <div class="px-4 lg:px-8">
            <p class="text-sm lg:text-lg text-center leading-relaxed md:px-2 mb-6">在字典卡上輸入單字字母即可查詢，單字字義唸給你聽。</p>
          </div>
        </div>
      </div>
      <div class="w-full md:w-1/3 px-2 xl:px-4 flex flex-col" data-aos="fade-top" data-aos-easing="ease" data-aos-once="false">
        <img src="~@/assets/images/readingPen2/photo-03.png" alt="livaABC" class="max-w-full object-contain mx-auto order-2 md:order-1">
        <div class="order-1 md:order-2">
          <h5 class="text-xl lg:text-2xl text-center font-bold mb-1 mt-6">LiveABC 出版品通用</h5>
          <div class="px-4 lg:px-8">
            <p class="text-sm lg:text-lg text-center leading-relaxed mb-1 md:hidden">只要是LiveABC出版的可點讀雜誌或叢書</p>
            <p class="text-sm lg:text-lg text-center leading-relaxed mb-6 md:hidden">(書封右上角有點讀筆圖示)，皆可使用。</p>

            <p class="text-sm lg:text-lg text-center leading-relaxed mb-6 hidden md:block">只要是LiveABC出版的可點讀雜誌或叢書(書封右上角有點讀筆圖示)，皆可使用。</p>
          </div>
        </div>
      </div>
      <div class="w-full md:w-1/3 px-2 xl:px-4 flex flex-col" data-aos="fade-top" data-aos-easing="ease" data-aos-once="false">
        <img src="~@/assets/images/readingPen2/photo-04.png" alt="livaABC" class="max-w-full object-contain mx-auto order-3 md:order-1">
        <div class="order-1 md:order-2">
          <h5 class="text-xl lg:text-2xl text-center font-bold mb-1 mt-6">大容量 存書方便</h5>
          <div class="px-4 lg:px-8">
            <p class="text-sm lg:text-lg text-center leading-relaxed md:px-2 mb-1 md:hidden">16G大容量記憶體，可存超過50本的書籍，</p>
            <p class="text-sm lg:text-lg text-center leading-relaxed md:px-2 mb-6 md:hidden">出廠時會先預置熱門叢書點讀音檔。</p>

            <p class="text-sm lg:text-lg text-center leading-relaxed md:px-2 mb-6 hidden md:block">16G大容量記憶體，可存超過50本的書籍，出廠時會先預置熱門叢書點讀音檔。</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 點讀筆相關說明 -->
    <div class="bg-white pt-4 pb-8 md:pb-12 px-8 md:px-12">
      <div class="flex flex-wrap lg:flex-no-wrap items-start mb-4">
        <div class="w-full lg:2/3 flex items-center flex-col xl:flex-row mb-8 md:mb-6">
          <img src="~@/assets/images/readingPen2/livepen-logo-02.png" alt="livaABC" class="max-w-full object-contain w-3/5 md:w-2/5 lg:w-auto mb-1">
          <h3 class="text-xl md:text-2xl lg:text-3xl md:-mb-4 ml-2 introText font-bold whitespace-no-wrap">點讀筆相關說明</h3>
        </div>
        <div class="w-full lg:1/3 lg:pl-6" data-aos="fade-left" data-aos-easing="ease" data-aos-once="false">
          <p style="color: #F9E13F;background: #093994;" class="leading-relaxed text-sm text-NotoSansLight font-hairline px-4 py-3 rounded-lg tracking-wider">
            點讀筆出廠時，為提供讀者使用上的便利，會預放約30-40本書籍音檔至點讀筆中。但因容量有限，無法將本公司出版之書籍音檔全部放入。倘若您無法點讀該書籍，可至本官網「下載專區」下載點讀音檔放入點讀筆中。若為壓縮檔，請先解壓縮後再存入BOOK資料夾，即可進行點讀。
          </p>
        </div>
      </div>
      <div class="flex flex-wrap justify-center items-center">
        <img src="~@/assets/images/readingPen2/pen-info.png" alt="livaABC" class="w-full md:w-2/5 object-contain mb-6 md:mb-0 md:pr-6 mx-auto" data-aos="fade-in" data-aos-easing="ease" data-aos-once="false">
        <img src="~@/assets/images/readingPen2/pen-info-2.png" alt="livaABC" class="w-fulll md:w-1/5 object-contain mb-6 md:mb-0 mx-auto px-4 md:px-0" data-aos="fade-in" data-aos-easing="ease" data-aos-once="false">

        <img src="~@/assets/images/readingPen2/LIVEPEN BOX 2.png" alt="livaABC" class="w-2/5 object-contain hidden md:block pl-6 mx-auto" data-aos="fade-in" data-aos-easing="ease" data-aos-once="false">
        <img src="~@/assets/images/readingPen2/LIVEPEN BOX 2-m.png" alt="livaABC" class="w-full object-contain md:hidden mx-auto" data-aos="fade-in" data-aos-easing="ease" data-aos-once="false">
      </div>
    </div>
    <!-- 點讀筆使用範例 -->
    <div class="flex flex-wrap example py-8 px-4 md:px-12">
      <div class="flex flex-col xl:flex-row xl:items-end pl-4 md:pl-0 w-full md:2/3 mb-4">
        <div class="flex items-center flex-col md:flex-row md:items-end mb-3 xl:mb-0">
          <img src="~@/assets/images/readingPen2/livepen-logo-whilte.png" alt="livaABC" class="max-w-full object-contain w-3/5 md:w-2/5 lg:w-auto">
          <h3 class="text-xl md:text-2xl lg:text-3xl ml-2 introText font-bold text-white md:-mb-2 whitespace-no-wrap">點讀筆使用範例</h3>
        </div>
        <p class="text-yellow xl:ml-4 text-xs md:text-base md:-mb-1 text-center md:text-left px-24 md:px-0 font-thin text-NotoSansLight">* 每本書可實際點讀發音之部分皆不同，依各書所列為準。</p>
      </div>
      <img src="~@/assets/images/readingPen2/boooks-info.png" alt="livaABC" class="max-w-full object-contain hidden md:block" data-aos="fade-in" data-aos-easing="ease" data-aos-once="false">
      <img src="~@/assets/images/readingPen2/boooks-info-m1.png" alt="livaABC" class="max-w-full object-contain md:hidden mx-auto" data-aos="fade-in" data-aos-easing="ease" data-aos-once="false">

      <div class="mobile-text md:hidden text-NotoSansLight pl-6">
        <p class="text-white text-sm leading-loose">➊ 筆符號｜點選此符號，即可聆聽整段發音</p>
        <p class="text-white text-sm leading-loose">➋ 句子｜只要點句中的其中一個單字，即可聆聽整句發音</p>
        <p class="text-white text-sm leading-loose">➌ 單字｜點單字也會發音喔</p>
      </div>
    </div>

    <!-- button -->
    <!-- <div class="fixed buy_bg flex justify-center flex-col items-end">
      <router-link  :to="{ name: 'productsList', params: { category: 'package' }, query: { type: 'PACKAGE', scope: 'smartpen_package_series' } }" class="buy_package block cursor-pointer w-4/5 md:w-auto">
        <img src="~@/assets/images/readingPen2/babo-off_01.png"
          class="max-w-full object-contain off" alt="Logo">
        <img src="~@/assets/images/readingPen2/babo-on_01.png"
          class="max-w-full object-contain on" alt="Logo">
      </router-link>
      <router-link  :to="{ name: 'detail', params: { category: 'package', id: 6559 } }" class="buy_pen block cursor-pointer w-4/5 md:w-auto">
        <img src="~@/assets/images/readingPen2/babo-off_02.png"
          class="max-w-full object-contain off" alt="Logo">
        <img src="~@/assets/images/readingPen2/babo-on_02.png"
          class="max-w-full object-contain on" alt="Logo">
      </router-link>
    </div> -->
    <!-- button -->
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'IntroPen',
  metaInfo () {
    return {
      title: '點讀筆'
    }
  },
  data () {
    return {
      price: null
    }
  },
  components: {
  },
  computed: {
  },
  mounted () {
    this.getPrice()
  },
  updated () {
  },
  methods: {
    toBuySmart () {
      this.$router.push({ name: 'detail', params: { category: 'package', id: 6559 } })
    },
    getPrice () {
      let self = this
      axios.get('/product/6559')
        .then((response) => {
          self.price = response.data.pricing.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  * {
    box-sizing: border-box;
  }
  .IntroPen {
    min-height: 200vh;
  }
  h3, h5, p {
    color: #000000b5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .BN {
    background-image: url('~@/assets/images/readingPen2/BG-01.png');
    background-origin: center;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  @media (min-width: 768px) {
    .sensitive {
      background: linear-gradient(270deg, #FFFFFF 50.95%, rgba(255, 255, 255, 0) 95.31%), #F2F2F2;
    }
  }
  .pb-72 {
    padding-bottom: 26rem;
  }
  .combine {
    background-image: url('~@/assets/images/readingPen2/BG-02.png');
    background-origin: center;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    @media (max-width: 767px) {
      background-image: url('~@/assets/images/readingPen2/BG-02-m.png');
    }
  }

  .introText {
    color: #093994;
  }
  .example {
    background-image: url('~@/assets/images/readingPen2/BG-03.png');
    background-origin: center;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .text-yellow {
    color: #F5CA00;
  }
  .video-container {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 30px;
    height: 0;
    overflow: hidden;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  .buy-Btn {
    transition: .3s;
    color: #000000b5;
    &:hover {
      background: #ff5733 !important;
    }
  }

  .buy_bg {
    right: 6rem;
    top: 11rem;
    @media (max-width: 1440px) {
      right: 1.2rem;
      top: 11em;
    }
    @media (max-width: 1024px) {
      right: 1.5rem;
      top: 11em;
    }
    @media (max-width: 768px) {
      right: 1.5rem;
      top: 12em;
    }
    @media (max-width: 576px) {
      right: .6rem;
      top: 12em;
    }
    .buy_package {
      .on {
        display: none;
      }
      &:hover {
        .on {
          display: block;
        }
        .off {
          display: none;
        }
      }
    }
    .buy_pen {
      .on {
        display: none;
      }
      &:hover {
        .on {
          display: block;
        }
        .off {
          display: none;
        }
      }
    }
  }
</style>
